import "@/i18n/config";
import React, { useEffect, useState } from "react";
import Avatar from "react-avatar";
import { Mention, MentionsInput } from "react-mentions";

import { Prop as CommentProps } from "./Comment";

import { CommunityMemberAvatar } from "@/client_app/components/CommunityMemberAvatar";
import { sendComment } from "@/client_app/components/CommunityMemberDetails/services/FetchAPIService";
import { PrimaryButton } from "@/ui/buttons";
const mentionStyle = {
  backgroundColor: "#cee4e5",
  overflow: "auto",
  maxHeight: "200px",
};

interface Prop extends CommentProps {
  onNbCommentChange?: (number: number) => void;
  defaultComments: object;
  recordName?: string;
  showRecordType?: boolean;
  hideAddComment?: boolean;
}

export function CommentContent({
  recordId,
  recordType,
  inAdmin,
  title,
  recordName,
  taggers,
  onNbCommentChange,
  defaultComments,
  showRecordType,
  hideAddComment,
}: Prop) {
  const [comment, setComment] = useState();
  const [comments, setComments] = useState(defaultComments);
  const [mentions, setMentions] = useState([]);

  useEffect(() => {
    setComments(defaultComments);
  }, [defaultComments]);
  const addComment = () => {
    const url = window.location.href;
    sendComment({
      recordId,
      recordType,
      content: comment,
      mentions: mentions,
      url: url,
      inAdmin,
    })
      .then((response) => response.json())
      .then((data) => {
        const length = comments?.[recordName]?.length || 0;
        onNbCommentChange?.(length + 1);

        setComments((prev) => ({
          ...prev,
          [recordName]: [...(prev[recordName] || []), data.comment],
        }));

        setComment(undefined);
        setMentions([]);
      });
  };

  const handleOnChange = (event, _, __, mentions) => {
    setComment(event.target.value);
    setMentions(mentions.map((mention) => mention.id));
  };

  return (
    <div className='px-1 py-2 w-full'>
      {title && (
        <div className='text-small font-bold border-neutral-200 border-b'>
          {title}
        </div>
      )}
      <div className='max-h-[500px] overflow-y-auto'>
        {comments &&
          Object.keys(comments).map((key) => (
            <div>
              {showRecordType && (
                <div className='capitalize font-bold pt-1'>
                  {key == "Position" ? "General Comments" : key}
                </div>
              )}
              {comments[key]?.map((comment, index) => (
                <div
                  className='border rounded-lg border-neutral-200 p-4 mt-4'
                  key={index}
                >
                  <div className='flex pb-2'>
                    <div className='self-center'>
                      {comment.profile_url ? (
                        <CommunityMemberAvatar
                          size='EXTRA_SMALL'
                          profileImageUrl={comment.profile_url}
                          name={comment.name}
                        />
                      ) : (
                        <Avatar
                          className='bg-primary-50 text-primary-900 rounded-full w-8 h-8'
                          name={comment.name}
                        />
                      )}
                    </div>
                    <div className='self-center pl-2 font-bold'>
                      {comment.name}
                    </div>
                    <div className='self-center pl-2 text-sm'>
                      {new Date(comment.time).toLocaleString("en-GB")}
                    </div>
                  </div>
                  <div>
                    <MentionsInput
                      className='comment-text'
                      value={comment.content}
                      disabled={true}
                    >
                      <Mention style={mentionStyle} />
                    </MentionsInput>
                  </div>
                </div>
              ))}
            </div>
          ))}
      </div>
      {!hideAddComment && (
        <div>
          <div className='divide h-[1px] bg-neutral-200 my-4'></div>
          <div>
            <MentionsInput
              className='mentions border-neutral-200 border '
              placeholder='Write a comment...use @ to tag'
              value={comment}
              onChange={(event, newValue, newPlainTextValue, mentions) =>
                handleOnChange(event, newValue, newPlainTextValue, mentions)
              }
            >
              <Mention
                style={mentionStyle}
                data={taggers.map((tagger) => ({
                  ...tagger,
                  display:
                    tagger.type == "User"
                      ? tagger.full_name + " (Weploy)"
                      : tagger.full_name,
                }))}
              />
            </MentionsInput>
          </div>
          <div className='float-right'>
            <PrimaryButton label='Submit' onClick={addComment} />
          </div>
        </div>
      )}
    </div>
  );
}
